module.exports = __webpack_public_path__ + "dad60f8e4adbe1ddf3be3ba72e4e5df6.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/beak/curvy-s.png
// module id = 1199
// module chunks = 0